import Typography from "../typography";
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";

declare module "@mui/material/TextField" {
  interface TextFieldPropsColorOverrides {
    textPrimary: true;
    textSecondary: true;
    textTertiary: true;
    textPlaceholder: true;
    textDisabled: true;
  }
}

export type TextFieldProps = MuiTextFieldProps & {
  id?: string;
  description?: string;
  dataDogIdentifier: string;
  startAdornment?: string;
  endAdornment?: React.ReactNode;
};

const TextField: React.FC<TextFieldProps> = (props) => {
  const {
    description,
    id = `textField-${Math.random().toString().slice(2, 8)}`,
    dataDogIdentifier,
    startAdornment,
    endAdornment,
    ...rest
  } = props;
  return (
    <>
      {description && (
        <Typography variant="body1" color="textPrimary" pb="10px">
          {description}
        </Typography>
      )}
      <MuiTextField
        {...rest}
        id={id}
        data-action-name={`${dataDogIdentifier} input`}
        {...(startAdornment && {
          slotProps: {
            input: {
              startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment>,
              endAdornment: endAdornment ? <InputAdornment position="end">{endAdornment}</InputAdornment> : undefined
            }
          }
        })}
      >
        {props.children}
      </MuiTextField>
    </>
  );
};

export default TextField;
